import React, { useState } from "react";
import { useGenerateGSTR1ReportMutation } from "../slices/gstApiSlice";

const GenerateGSTR1Report = () => {
  const [vendorId, setVendorId] = useState("");
  const [period, setPeriod] = useState(""); // Format: YYYY-MM
  const [report, setReport] = useState(null);

  const [generateGSTR1Report, { isLoading }] = useGenerateGSTR1ReportMutation();

  const handleGenerate = async () => {
    if (!vendorId || !period) {
      alert("Please enter both Vendor ID and Period (YYYY-MM).");
      return;
    }

    try {
      const response = await generateGSTR1Report({ vendorId, period }).unwrap();
      setReport(response.report); // Show the generated report
    } catch (err) {
      console.error(err);
      alert("Failed to generate GSTR-1 report. Check console for details.");
    }
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "600px", margin: "0 auto" }}>
      <h2>Generate GSTR-1 Report</h2>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          Vendor ID:
          <input
            type="text"
            value={vendorId}
            onChange={(e) => setVendorId(e.target.value)}
            placeholder="Enter Vendor ID"
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.25rem" }}
          />
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          Period (YYYY-MM):
          <input
            type="text"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            placeholder="e.g., 2026-01"
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.25rem" }}
          />
        </label>
      </div>

      <button
        onClick={handleGenerate}
        disabled={isLoading}
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: "#4CAF50",
          color: "#fff",
          border: "none",
          cursor: isLoading ? "not-allowed" : "pointer",
        }}
      >
        {isLoading ? "Generating..." : "Generate Report"}
      </button>

      {report && (
        <div style={{ marginTop: "2rem" }}>
          <h3>Generated GSTR-1 Report</h3>
          <pre
            style={{
              backgroundColor: "#f4f4f4",
              padding: "1rem",
              overflowX: "auto",
            }}
          >
            {JSON.stringify(report, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default GenerateGSTR1Report;
